import { feeds } from "../../apis/services";
import {
  FETCH_MASTER_CONFIG,
  FETCH_DEFAULT_MASTER_CONFIG_GATED_CONTENT,
} from "../../constants/masterConfig";

export const getMasterConfig = (params) => ({
  type: FETCH_MASTER_CONFIG,
  payload: feeds.getMasterConfig(params),
});

export const overrideGatedContentFromDefaultConfig = (params) => ({
  type: FETCH_DEFAULT_MASTER_CONFIG_GATED_CONTENT,
  payload: feeds.getMasterConfig(params),
});
